const COUNTRY_TIMEZONE_MAP = {
  ARE: 'Asia/Dubai',
  ARG: 'America/Argentina/Buenos_Aires',
  AUS: 'Australia/Sydney',
  AUT: 'Europe/Vienna',
  BEL: 'Europe/Brussels',
  BGD: 'Asia/Dhaka',
  BRA: 'America/Sao_Paulo',
  CAN: 'America/Toronto',
  CHE: 'Europe/Zurich',
  CHL: 'America/Santiago',
  CHN: 'Asia/Shanghai',
  COL: 'America/Bogota',
  CYP: 'Asia/Nicosia',
  CZE: 'Europe/Prague',
  DEU: 'Europe/Berlin',
  DNK: 'Europe/Copenhagen',
  DZA: 'Africa/Algiers',
  EGY: 'Africa/Cairo',
  ESP: 'Europe/Madrid',
  EST: 'Europe/Tallinn',
  FIN: 'Europe/Helsinki',
  FRA: 'Europe/Paris',
  GBR: 'Europe/London',
  GRC: 'Europe/Athens',
  HKG: 'Asia/Hong_Kong',
  HUN: 'Europe/Budapest',
  IDN: 'Asia/Jakarta',
  IND: 'Asia/Kolkata',
  IRL: 'Europe/Dublin',
  IRQ: 'Asia/Baghdad',
  ISR: 'Asia/Jerusalem',
  ITA: 'Europe/Rome',
  JPN: 'Asia/Tokyo',
  KAZ: 'Asia/Almaty',
  KOR: 'Asia/Seoul',
  KWT: 'Asia/Kuwait',
  LBN: 'Asia/Beirut',
  LKA: 'Asia/Colombo',
  LTU: 'Europe/Vilnius',
  LUX: 'Europe/Luxembourg',
  LVA: 'Europe/Riga',
  MAR: 'Africa/Casablanca',
  MEX: 'America/Mexico_City',
  MYS: 'Asia/Kuala_Lumpur',
  NGA: 'Africa/Lagos',
  NLD: 'Europe/Amsterdam',
  NOR: 'Europe/Oslo',
  NZL: 'Pacific/Auckland',
  OMN: 'Asia/Muscat',
  PAK: 'Asia/Karachi',
  PER: 'America/Lima',
  PHL: 'Asia/Manila',
  POL: 'Europe/Warsaw',
  PRT: 'Europe/Lisbon',
  QAT: 'Asia/Qatar',
  ROU: 'Europe/Bucharest',
  RUS: 'Europe/Moscow',
  SAU: 'Asia/Riyadh',
  SGP: 'Asia/Singapore',
  SVK: 'Europe/Bratislava',
  SVN: 'Europe/Ljubljana',
  SWE: 'Europe/Stockholm',
  THA: 'Asia/Bangkok',
  TUR: 'Europe/Istanbul',
  TWN: 'Asia/Taipei',
  UKR: 'Europe/Kiev',
  USA: 'America/New_York',
  UZB: 'Asia/Tashkent',
  VNM: 'Asia/Ho_Chi_Minh',
  ZAF: 'Africa/Johannesburg'
};

const getTimezoneForCountry = countryCode => COUNTRY_TIMEZONE_MAP[countryCode] || null;

export default getTimezoneForCountry;
